import { ExpandMore } from "@mui/icons-material";
import { CollapsibleCard } from "components/shared/components/CollapsibleCard";
import { ReactNode, useState } from "react";
import styles from "./SuccessPlan.module.scss";
import { IconButton } from "@mui/material";

type SuccessPlanCardProps = {
  children: ReactNode;
  titleSlot: ReactNode;
};

function renderTitle(titleSlot: ReactNode) {
  if (typeof titleSlot === "string") {
    return <span className={styles["card-title"]}>{titleSlot}</span>;
  }

  return titleSlot;
}

const SuccessPlanCard = ({ children, titleSlot }: SuccessPlanCardProps) => {
  const [open, setOpen] = useState(true);
  return (
    <CollapsibleCard
      className={styles.card}
      expanded={open}
      onExpandedChange={setOpen}
    >
      <CollapsibleCard.Header
        className={`${styles["card-header"]} ${open ? null : styles["card-header-all-radius"]}`}
      >
        <CollapsibleCard.Trigger asChild>
          <IconButton size="small">
            <ExpandMore
              className={`${styles["expand-icon"]} ${open ? styles["expand-icon--expanded"] : styles["expand-icon--collapsed"]}`}
            />
          </IconButton>
        </CollapsibleCard.Trigger>
        {renderTitle(titleSlot)}
      </CollapsibleCard.Header>
      <CollapsibleCard.Body
        className={styles["card-body"]}
        contentClassName={styles["card-body-content"]}
      >
        {children}
      </CollapsibleCard.Body>
    </CollapsibleCard>
  );
};

export default SuccessPlanCard;
